import { render, staticRenderFns } from "./permohonan.vue?vue&type=template&id=877accaa"
import script from "./permohonan.vue?vue&type=script&lang=js"
export * from "./permohonan.vue?vue&type=script&lang=js"
import style1 from "./permohonan.vue?vue&type=style&index=1&id=877accaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports